import React from "react";
import MasterClassTable from "./MasterClassTable";

function MasterClassView() {
  return <MasterClassTable />;
}

export default MasterClassView;

